export default __webpack_public_path__ + "static/media/icon_home_gray.dc834fe7.svg";